// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown__item.hidden[data-v-04ba9e02] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
